// Cache local del catálogo de ExpendiosSolicitudes.
// Clave: código de expendio (por ejemplo, "02").
// Valor: nombre proveniente de la base de datos (evita hardcodes en el front).
// Se precarga al iniciar la app en `src/main.js` para resolver nombres por código en toda la UI.
const state = {
  expendiosByCodigo: {},
};

export default state;
